import { render, staticRenderFns } from "./addressNew.vue?vue&type=template&id=77cc50f1"
import script from "./addressNew.vue?vue&type=script&lang=js"
export * from "./addressNew.vue?vue&type=script&lang=js"
import style0 from "./addressNew.vue?vue&type=style&index=0&id=77cc50f1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports